import { readdir } from 'node:fs/promises';
import { pagesDiff } from '@wix/ambassador-velo-apps-v1-app/http';
import type { PagesDiffRequest } from '@wix/ambassador-velo-apps-v1-app/types';
import { GridAppLayout } from '@wix/ambassador-velo-apps-v1-app/types';
import {
  getPagesFolder,
  getSourceFolder,
} from '@wix/velo-github-layout-definitions';
import type { AuthState } from '@wix/cli-auth';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { pathExists } from '@wix/cli-fs';
import { httpRequest } from '../http-request.js';
import type { ProjectModel } from '../model.js';
import { createPages, deletePages, renamePages } from './pages-diff.js';

export async function syncPages(
  model: ProjectModel,
  opts: {
    authState: AuthState;
  }
): Promise<void> {
  const pagesFolder = getPagesFolder(model.projectFolder);

  if (!(await pathExists(pagesFolder))) {
    throw new CliError({
      code: CliErrorCode.NoPagesDirectoryFound({
        srcDir: getSourceFolder(model.projectFolder),
      }),
      cause: null,
    });
  }

  const params: PagesDiffRequest = {
    layout: GridAppLayout.GITHUB,
    sourcePagesPaths: await readdir(pagesFolder),
    targetRevision: model.revision,
  };
  const { data } = await httpRequest(
    {
      authState: opts.authState,
      type: 'code',
    },
    pagesDiff(params)
  ).catch((e: unknown) => {
    throw new CliError({
      code: CliErrorCode.FailedToGetPagesDiff(),
      cause: e,
      info: { ...params },
    });
  });

  await Promise.all([
    createPages(model.projectFolder, data.pagesDiff?.created ?? []),
    renamePages(model.projectFolder, data.pagesDiff?.renamed ?? []),
    deletePages(model.projectFolder, data.pagesDiff?.deleted ?? []),
  ]);
}
